<template>
    <material-input
        v-model="address"
        class="mb-2"
        label="Adres"
    />
    <material-input
        v-model="zipCode"
        class="mb-2"
        label="Postcode"
    />
    <material-input
        v-model="city"
        class="mb-2"
        label="Plaats"
    />

    <hr />

    <material-input
        v-model="latitude"       
        class="mb-2"
        label="Breedtegraad"
    />
    <material-input
        v-model="longitude"
        class="mb-2"
        label="Lengtegraad"
    />
    <material-button
      @click.prevent="fillLatLngForAddress"
    >
      Vul coördinaten in
    </material-button>
</template>

<script>
import Geocoding from '@/helpers/maps/geocoding';
import ReportEditStore from '@/store/pages/Report/report-edit-store';

import MaterialButton from '@/components/MaterialButton.vue';
import MaterialInput from '@/components/MaterialInput.vue';

export default {
    components: {
        MaterialButton,
        MaterialInput,
    },

    data() {
        return {
            geocoding: new Geocoding(),
        }
    },

    computed: {
        address: {
            get: () => ReportEditStore.getters.editingReport.address,
            set: (v) => ReportEditStore.dispatch('updateEditingAddress', v),
        },
        zipCode: {
            get: () => ReportEditStore.getters.editingReport.zipCode,
            set: (v) => ReportEditStore.dispatch('updateEditingZipCode', v),
        },
        city: {
            get: () => ReportEditStore.getters.editingReport.city,
            set: (v) => ReportEditStore.dispatch('updateEditingCity', v),
        },
        latitude: {
            get: () => ReportEditStore.getters.editingReport.latitude,
            set: (v) => ReportEditStore.dispatch('updateEditingLatitude', v),
        },
        longitude: {
            get: () => ReportEditStore.getters.editingReport.longitude,
            set: (v) => ReportEditStore.dispatch('updateEditingLongitude', v),
        }
    },

    methods: {
      async fillLatLngForAddress() {
        let location = await this.getLocationLatLong();
        if (location == null) {
          // TODO: Add error message
          return;
        }

        this.latitude = location.latitude;
        this.longitude = location.longitude;
      },

      async getLocationLatLong() {
        let location = `${this.address} ${this.city}, ${this.zipCode}`;
        return await this.geocoding.getLatLongFromAddress(location);
      }
    }
}
</script>